import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

import { computed, shallowRef } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { BooksChoice } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import BooksPick from '../BooksPick.vue'
import BooksDone from '../BooksDone.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Books',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const currentComponent = shallowRef<typeof BooksPick | typeof BooksDone>(
  BooksPick,
)

const currentChoices = computed(() => {
  return props.view.currentChoice as BooksChoice
})

function nextPage(): void {
  const hasLikedBookes = currentChoices.value.some((book) => book.score > 0)

  if (hasLikedBookes) {
    currentComponent.value = BooksDone
    return
  }

  props.view.nextPage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentComponent)), {
        view: __props.view,
        onDone: nextPage
      }, null, 40, ["view"]))
    ]),
    _: 1
  }))
}
}

})